import type { ResultResponseDto } from 'app/API';
import { OpenAPI } from 'app/API/core/OpenAPI';
import { request } from 'app/API/core/request';
import type {
  CreateSuperEnhancementMessageBodyDto,
  SuperEnhancementChatMessageResponseDto,
  StartSuperEnhancementBodyDto,
  SuperEnhancementResponseDto,
} from 'app/API/models';

export const superEnhancementApi = {
  deleteInstruction: (jobId: string, messageId: string) =>
    request<void>(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/jobs/{jobId}/super-enhancement/messages/{messageId}',
      path: { jobId, messageId },
    }),
  messages: (jobId: string) =>
    request<SuperEnhancementChatMessageResponseDto[]>(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/super-enhancement/messages',
      path: { jobId },
    }),
  createMessage: (jobId: string, message: CreateSuperEnhancementMessageBodyDto) =>
    request<SuperEnhancementChatMessageResponseDto>(OpenAPI, {
      method: 'POST',
      url: '/api/admin/jobs/{jobId}/super-enhancement/messages',
      path: { jobId },
      body: message,
      mediaType: 'application/json',
    }),

  availability: (jobId: string) =>
    request<ResultResponseDto>(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/super-enhancement/availability',
      path: { jobId },
    }),
  get: (jobId: string) =>
    request<SuperEnhancementResponseDto>(OpenAPI, {
      method: 'GET',
      url: '/api/admin/jobs/{jobId}/super-enhancement',
      path: { jobId },
    }),
  start: (jobId: string, options: StartSuperEnhancementBodyDto) =>
    request<void>(OpenAPI, {
      method: 'POST',
      body: options,
      mediaType: 'application/json',
      url: '/api/admin/jobs/{jobId}/super-enhancement',
      path: { jobId },
    }),
};
